export default {
	API: "https://monitor.arcelormittal.tcsapp.com.br/api/v1",
	API_MONITOR: "https://api-monitor.usecarcarsharing.com.br/api/status-report"
};
